var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[(_vm.agency.id == '1539642')?_c('IDCardASCHMA'):_vm._e(),(_vm.agency.id == '930972')?_c('IDCardFHIS'):(_vm.agency.id != '1539642')?_c('IDCardZAMCHEMA'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }